<template>
	<div :class="gridClass">
		<div class="grid-column" :data-column-index="column" v-for="column in $store.getters.preferenceColumnCount">

			<div class="grid-item" v-for="category in columnCategories(column)" :data-uid="category.id" :class="categoryTheme(category.theme)" @mousedown.prevent="mousedownCategories(category,$event)">
				<div class="grid-item-box theme-bg-2 theme-color-2">
					<header class="category-header">
						<div class="category-title">{{ category.name }}</div>
						<div class="category-actions theme-color-2">
							<span class="category-button category-button-newlink" @click="newLink(category)" title="Adicionar link">+</span>
							<span class="category-button category-button-editar" @click="editCategory(category)" title="Editar esta caixa"><i><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.08 20.21,11.08 20.42,11.3L21.7,12.58C21.92,12.79 21.92,13.14 21.7,13.35M12,18.94L18.07,12.88L20.12,14.93L14.06,21H12V18.94M4,2H18A2,2 0 0,1 20,4V8.17L16.17,12H12V16.17L10.17,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,6V10H10V6H4M12,6V10H18V6H12M4,12V16H10V12H4Z" /></svg></i></span>
							<span class="is-hidden-desktop category-button category-button-mover" @touchstart.prevent="mousedownCategories(category,$event)"><i><svg viewBox="0 0 24 24"><path d="M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z" /></svg></i></span>
						</div>

					</header>
					<div class="links-container" :class="['links-container-'+category.id]">

						<div class="link-item" :class="{editando:movendo && movendoItem==item}" v-for="item in categoryLinks(category.id)" :key="item.id" :track-by="item.id" :data-uid="item.id" :item="item" @contextmenu="contextMenu(item,$event)" @mousedown.prevent="mousedownLinks(item,$event)" @mousemove.prevent>
							<a :href="item.url" target="_blank" :title="item.hover" @click="clickLink(item,$event)">
								<span class="favicon"><img class="favicon-image" :src="item.favicon" onerror="this.src='images/favicon-default.png'"></span>
								<ins class="theme-color-2">{{ item.name }}</ins>
							</a>
							<div v-if="movendo && movendoItem==item" class="dragOverlay" @touchstart.prevent="touchstartLinks(item,$event)" @touchmove.prevent="touchmoveLinks($event)"></div>

						</div>

					</div>

				</div>

			</div>

		</div>
		<div class="context-menu" id="ctxMenu" v-show="ctxmenu">
			<ul>
				<li @click="copyLink(contextMenuItem,$event)">Copiar link</li>
				<li @click="editLink(contextMenuItem)">Editar</li>
				<li @click="duplicateLink(contextMenuItem)">Duplicar</li>
				<li @click="removeLink(contextMenuItem)">Excluir</li>
			</ul>
		</div>
		<div class="link-preview" v-if="linkPreview" @click="linkPreview = false">
			<div class="link-preview-content" @click.stop>

				<a :href="linkPreviewItem.url" target="_blank">
					<figure>
						<img :src="linkPreviewItem.favicon">
					</figure>
					<h2>{{ linkPreviewItem.name }}</h2>
					<span>Abrir</span>
				</a>

				<ul>
					<li @click="copyLink(linkPreviewItem,$event)">Copiar link</li>
					<li @click="editLink(linkPreviewItem)">Editar</li>
					<li @click="duplicateLink(linkPreviewItem)">Duplicar</li>
					<li @click="removeLink(linkPreviewItem)">Excluir</li>
					<li @click="habilitaMover(linkPreviewItem,$event)">Mover</li>
				</ul>
			</div>
		</div>

	</div>
</template>

<style >
.grid {width: 975px; flex-shrink: 0;}

@media (max-width:1365px){
	.grid {width: 915px; }
}
@media (max-width:991px){
	.grid {width: 100%; }
}

.grid-columns-3{ display: flex; }
.grid-columns-2{ display: flex; }
.grid-column {flex:1;}
.grid-item {width:100%; padding:5px; user-select: none; }
.grid-item-box{ min-height:100px; color:#fff; position: relative; box-shadow:0px 0px 5px 3px rgba(0,0,0,0.20); border-radius: 5px;}
.grid-item-box:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	border-radius: 5px;
}
.grid-has-opacity .grid-item-box:before {
	opacity: 0.6;
}
.grid-transparency-0 .grid-item-box:before {opacity: 1; }
.grid-transparency-40 .grid-item-box:before {opacity: 0.6; }
.grid-transparency-100 .grid-item-box:before {opacity: 0; }

.grid-transparency-100 .category-header { border-bottom-color:transparent !important }

.category-header { padding:10px 20px; display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 1px solid #ccc; padding-bottom: 5px; margin-bottom: 5px; z-index:2;  position: relative;}
.category-title { word-break: break-all; }

.category-actions { opacity: .1; flex-shrink: 0; display: flex; margin-right: -10px; color:#fff; }

.category-button { margin:0 3px; line-height: 1; cursor: pointer; height: 20px; }
.category-button-newlink { line-height: 20px; width:20px; font-size: 26px; text-align:center; }
.link-item-new {}
.link-item-new span {  }
.link-item-new span:after { }


.category-button-editar {  }
.category-button-editar i { display:inline-block; width:20px; height:23px; }
.category-button-editar svg { display: block; width:100%; height:100%; }
.category-button-editar svg path{ fill:#fff;}

.category-button-mover {  }
.category-button-mover i { display:inline-block; width:20px; height:20px; }
.category-button-mover svg { display: block; width:110%; height:110%; }
.category-button-mover svg path{ fill:#fff;}


.grid-item:hover .category-actions { opacity: 1; }
body.is-mobile .grid-item .category-actions {  margin-top:-10px; margin-right:-10px; margin-bottom:-10px;  opacity: 1; }
body.is-mobile .grid-item .category-actions .category-button { margin:0; padding:10px; height:40px; }

body.is-mobile .grid-item .category-actions .category-button-mover { padding:8px;}
body.is-mobile .grid-item .category-actions .category-button-mover i { width: 21px; height:21px; }

body.is-mobile .category-button-newlink { width:40px; }
.links-container { padding:10px 19px; margin-left:-10px; z-index:2; position: relative;}

.grid-item.placeholder {outline: 3px dashed #1cc4cf; outline-offset: -6px; transition: transform 0.2s; }
.grid-item.dragging {
  position: fixed;
  z-index: 4;
  transform: rotate(-2deg);
  /*background: #1cc4cf; */
}
.grid-item.dragging .grid-item-box {
	box-shadow: 5px 5px 5px rgba(0,0,0,.2);
}


.link-item { position: relative; }
.link-item.placeholder {
	outline: 1px dashed #1cc4cf;
	transition: transform 0.2s;
min-width: 47px;
min-height: 69px;
display: inline-block;
}
.link-item.editando {
	animation: isEditing .25s infinite;
}
.dragOverlay {
	position: absolute;
	top:0; left:0; right:0; bottom:0;
	outline: 1px dashed #1cc4cf;
}
.link-item.dragging {
  pointer-events: none;
  position: fixed;
  box-shadow: 5px 5px 5px rgba(0,0,0,.2);
  z-index: 2;
  transform: rotate(-3deg);
  /*background: #1cc4cf; */
}

.context-menu {position: absolute; z-index: 3; background-color:#fff; box-shadow: 1px 1px 5px rgba(0,0,0,.8) }
.context-menu ul {}
.context-menu li {cursor:pointer; padding: 3px 15px; font-size: 12px; }
.context-menu li:hover {background-color: #0fbdc9; color:#fff;}



.grid-size-61{  }
.grid-size-61 .link-item a{ width:61px; }
.grid-size-61 .favicon{ width:61px; height:61px; }
.grid-size-61 .link-item.placeholder { min-width: 61px; min-height: 83px }
.grid-size-47{  }
.grid-size-47 .link-item a{ width:47px; }
.grid-size-47 .favicon{ width:47px; height:47px; }
.grid-size-47 .link-item-new span:after { line-height: 38px;}

.grid-corners-1 .favicon {border-radius:0;}
.grid-corners-2 .favicon { border-radius:7px; }
.grid-corners-3 .favicon {border-radius:100px; }


.category-theme-00FFFF-FFFFFF .grid-item-box:before { background-color:#00FFFF !important; color:#FFFFFF !important; }
.category-theme-00FFFF-FFFFFF .category-header { color:#FFFFFF !important; }
.category-theme-00FFFF-FFFFFF .link-item a ins { color:#FFFFFF !important; }
.category-theme-00FFFF-FFFFFF .category-button { color:#FFFFFF !important; }
.category-theme-00FFFF-FFFFFF .category-button svg path { fill:#FFFFFF !important; }
.category-theme-8A2BE2-FFFFFF .grid-item-box:before { background-color:#8A2BE2 !important; color:#FFFFFF !important; }
.category-theme-8A2BE2-FFFFFF .category-header { color:#FFFFFF !important; }
.category-theme-8A2BE2-FFFFFF .link-item a ins { color:#FFFFFF !important; }
.category-theme-8A2BE2-FFFFFF .category-button { color:#FFFFFF !important; }
.category-theme-8A2BE2-FFFFFF .category-button svg path { fill:#FFFFFF !important; }
.category-theme-5F9EA0-FFFFFF .grid-item-box:before { background-color:#5F9EA0 !important; color:#FFFFFF !important; }
.category-theme-5F9EA0-FFFFFF .category-header { color:#FFFFFF !important; }
.category-theme-5F9EA0-FFFFFF .link-item a ins { color:#FFFFFF !important; }
.category-theme-5F9EA0-FFFFFF .category-button { color:#FFFFFF !important; }
.category-theme-5F9EA0-FFFFFF .category-button svg path { fill:#FFFFFF !important; }
.category-theme-FF6347-FFFFFF .grid-item-box:before { background-color:#FF6347 !important; color:#FFFFFF !important; }
.category-theme-FF6347-FFFFFF .category-header { color:#FFFFFF !important; }
.category-theme-FF6347-FFFFFF .link-item a ins { color:#FFFFFF !important; }
.category-theme-FF6347-FFFFFF .category-button { color:#FFFFFF !important; }
.category-theme-FF6347-FFFFFF .category-button svg path { fill:#FFFFFF !important; }
.category-theme-4682B4-FFFFFF .grid-item-box:before { background-color:#4682B4 !important; color:#FFFFFF !important; }
.category-theme-4682B4-FFFFFF .category-header { color:#FFFFFF !important; }
.category-theme-4682B4-FFFFFF .link-item a ins { color:#FFFFFF !important; }
.category-theme-4682B4-FFFFFF .category-button { color:#FFFFFF !important; }
.category-theme-4682B4-FFFFFF .category-button svg path { fill:#FFFFFF !important; }
.category-theme-303030-FFFFFF .grid-item-box:before { background-color:#303030 !important; color:#FFFFFF !important; }
.category-theme-303030-FFFFFF .category-header { border-color:#444 !important; }
.category-theme-303030-FFFFFF .link-item a ins { color:#FFFFFF !important; }
.category-theme-303030-FFFFFF .category-button { color:#FFFFFF !important; }
.category-theme-303030-FFFFFF .category-button svg path { fill:#FFFFFF !important; }
.category-theme-F8F8F8-303030 .grid-item-box:before { background-color:#F8F8F8 !important; color:#303030 !important; }
.category-theme-F8F8F8-303030 .category-header { color:#303030 !important; border-color:#444 !important; }
.category-theme-F8F8F8-303030 .link-item a ins { color:#303030 !important; }
.category-theme-F8F8F8-303030 .category-button { color:#303030 !important; }
.category-theme-F8F8F8-303030 .category-button svg path { fill:#303030 !important; }
.category-theme-FFFFFF-303030 .grid-item-box:before { background-color:#FFFFFF !important; color:#303030 !important; }
.category-theme-FFFFFF-303030 .category-header { color:#303030 !important; }
.category-theme-FFFFFF-303030 .link-item a ins { color:#303030 !important; }
.category-theme-FFFFFF-303030 .category-button { color:#303030 !important; }
.category-theme-FFFFFF-303030 .category-button svg path { fill:#303030 !important; }

.link-preview {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0,0,0,0.7);
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;

}
.link-preview-content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #fff;
	text-align:center;
	padding:20px;
 }
.link-preview figure { height: 60px; margin:0 auto 10px; display: flex; justify-content: center;align-items: flex-end;}
.link-preview img { width:auto; height:auto; max-width: 60px; max-height: 60px; }
.link-preview a { color:#fff;}
.link-preview h2 { font-size: 22px; margin-bottom: 5px;}
.link-preview span {}
.link-preview ul { margin-top:5px; }
.link-preview li { padding:5px; }


@media (min-width:1366px){
  .grid-size-47.grid-columns-1 .links-container{  }
  .grid-size-47.grid-columns-1 .link-item{ margin-left:8px; }

  .grid-size-47.grid-columns-2 .links-container{ padding:10px 18px; }
  .grid-size-47.grid-columns-2 .link-item{ margin-left:9px }

  .grid-size-47.grid-columns-3 .link-item{  }


  .grid-size-61.grid-columns-1 .links-container{ padding-left:18px; padding-right:18px; }
  .grid-size-61.grid-columns-1 .link-item{ margin-left:11px;}

  .grid-size-61.grid-columns-2 .links-container{  }
  .grid-size-61.grid-columns-2 .link-item{ margin-left:13px; }

  .grid-size-61.grid-columns-3 .links-container{  }
  .grid-size-61.grid-columns-3 .link-item{ }
}

@media (max-width:1365px){

  .grid-size-47.grid-columns-1 .links-container{ padding-left:16px; padding-right:16px;}
  .grid-size-47.grid-columns-1 .link-item{ margin-left:8px; }

  .grid-size-47.grid-columns-2 .links-container{ padding-left:17px; padding-right:17px; }
  .grid-size-47.grid-columns-2 .link-item{ margin-left:13px; }

  .grid-size-47.grid-columns-3 .links-container{ padding-left:11px; padding-right:11px;}
  .grid-size-47.grid-columns-3 .link-item{ margin-left:9px; }


  .grid-size-61.grid-columns-1 .links-container{ padding-left:18px; padding-right:18px;  }
  .grid-size-61.grid-columns-1 .link-item{margin-left:12px; }

  .grid-size-61.grid-columns-2 .links-container{ padding-left:14px; padding-right:14px;  }
  .grid-size-61.grid-columns-2 .link-item{  }

  .grid-size-61.grid-columns-3 .links-container{ padding-left:12px; padding-right:11px; }
  .grid-size-61.grid-columns-3 .link-item{ margin-left: 9px }

}


</style>

<script>


		export default {
		computed: {
			config(){
				return this.$store.state.config;
			},
			preferences(){
				return this.$store.getters.preferences;
			},
			user() {
				return this.$store.getters.user;
			},
			userId() {
				return this.$store.getters.userId;
			},
			categories(){
				return this.$store.getters.orderedCategories
			},
			links(){
				return this.$store.getters.orderedLinks;
			},

			gridClass(){
				var class_arr = [
				'grid-size-'+this.$store.getters.preferenceIconSize,
				'grid-corners-'+this.$store.getters.preferenceIconCorners,
				'grid-columns-'+this.$store.getters.preferenceColumnCount,
				'grid-transparency-'+this.$store.getters.preferenceTransparency,
				'grid-textColor-'+this.$store.getters.preferenceTextColor,
				];
				//if(this.$store.getters.preferenceHasOpacity) class_arr.push('grid-has-opacity');
				return class_arr;
			},
		},
		data(){
			return {
				debug:{},
				ctxmenu:false,
				contextMenuItem:null,

				linkPreview:false,
				linkPreviewItem:null,

				movendo:false,
				movendoItem:null,

				dndCat:{
					mouseDown:false,
					dragging:false,
					category:null,
					element:null,
					offset:{x:0, y:0, },
					mouse:{x:0, y:0, },
					columnHover:null,
					indexHover:null,
				},
				dndLinks:{
					mouseDown:false,
					dragging:false,
					link:null,
					element:null,
					offset:{x:0, y:0, },
					mouse:{x:0, y:0, },
					categoryHover:null,
					indexHover:null,
					touchstart:null,
				},

			}
		},
		methods:{

			columnCategories(column){
				return this.categories.filter(cat => cat.column?cat.column==column:column==1);
			},

			categoryLinks(category_id){
				return this.$store.getters.categoryLinks(category_id);
			},

			getColumnHover(x){
				var column = null;
				for(var index = 1;index<=this.$store.getters.preferenceColumnCount;index++){
					var rect = document.querySelector('.grid-column:nth-child('+index+')').getBoundingClientRect();
					if(x >= rect.x && x <= rect.x+rect.width) return index;
				}
				return null;
			},

			getIndexHover(columnIndex,y){
				var indexHover = null;
				var categories = this.columnCategories(columnIndex);
				var index;
				for (index in categories){
					if(categories[index].id == this.dndCat.element.getAttribute('data-uid')) continue;
					var rect = document.querySelector('.grid-item[data-uid="'+categories[index].id+'"]').getBoundingClientRect();
					if(y <= rect.y) return categories[index].index;
					if(y >= rect.y && y <= rect.y+rect.height/2) return categories[index].index;
					if(y >= rect.y+rect.height/2 && y <= rect.y+rect.height) return categories[index].index+1;
				}
				return null
			},

			mousedownCategories(category,e){

				if(e.type=='touchstart'){
					var target = document.querySelector('.grid-item[data-uid="'+category.id+'"]');
					var coords = {
						x:e.touches[0].pageX,
						y:e.touches[0].pageY,
					}
					var rect = target.getBoundingClientRect();
					var offset = {
						x:e.targetTouches[0].clientX - rect.left,
						y:e.targetTouches[0].clientY - rect.top,
					}
				} else {
					var coords = {
						x:e.clientX,
						y:e.clientY,
					}
					var offset = {
						x:e.offsetX,
						y:e.offsetY,
					}
				}

				this.dndCat.category = category;
				this.dndCat.element = document.querySelector('.grid-item[data-uid="'+category.id+'"]');
				this.dndCat.offset.x = offset.x;
				this.dndCat.offset.y = offset.y;

	      //record coordinates to start draggin 10px after this
	      this.dndCat.mouse.x = coords.x;
	      this.dndCat.mouse.y = coords.y;

	      this.dndCat.mouseDown = true;

	    },

	    mousemoveCategories(coords){
	    	var movePlaceholder = false;

	    	if(!this.dndCat.dragging){
	    		if(Math.abs(this.dndCat.mouse.x-coords.x)<10 && Math.abs(this.dndCat.mouse.y-coords.y)<10) return;
	    		this.dndCat.dragging = true;
	    		this.dndCat.element.style.width = this.dndCat.element.offsetWidth+'px';
	    		this.$nextTick(()=>{
		    		this.dndCat.element.classList.add('dragging');
     			})
	    		movePlaceholder = true;
	    	}

	    	this.dndCat.element.style.left = (coords.x - this.dndCat.offset.x) + 'px';
	    	this.dndCat.element.style.top = (coords.y - this.dndCat.offset.y) + 'px';

	    	var columnHover = this.getColumnHover(coords.x);
	    	if(columnHover && this.dndCat.columnHover!=columnHover){
	    		console.log('change column ',columnHover);
	    		this.dndCat.columnHover = columnHover;
	    		movePlaceholder = true;
	    	}

	    	var indexHover = this.getIndexHover(columnHover,coords.y);
	    	if(indexHover && this.dndCat.indexHover!=indexHover){
	    		console.log('change index ',indexHover);
	    		this.dndCat.indexHover = indexHover;
	    		movePlaceholder = true;
	    	}

	    	if(movePlaceholder) {
	        //remove existing placeholder
	        document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); });

	        //create new placeholder
	        var placeholder = document.createElement('div');
	        placeholder.className = 'grid-item placeholder';
	        placeholder.style.height = this.dndCat.element.offsetHeight+'px';

	        //insert on chosen position
	        var categories = this.categories.filter(cat => cat.column==this.dndCat.columnHover && cat.index==this.dndCat.indexHover);
	        if(categories.length){
	        	var categoryElement = document.querySelector('.grid-item[data-uid="'+categories[0].id+'"]');
	        	categoryElement.parentNode.insertBefore(placeholder,categoryElement);
	        } else {
	        	document.querySelector('.grid-column:nth-child('+this.dndCat.columnHover+')').appendChild(placeholder);
	        }
	      }
	    },

	    mouseupCategories(e){
	    	this.dndCat.dragging = false;
	      //setar column do elemento arrastado
	      this.dndCat.category.index= this.dndCat.indexHover-0.5;
	      this.dndCat.category.column=this.dndCat.columnHover;

	      //atualizar index dos demais elementos
	      this.$store.dispatch('reorderCategories');

	      this.dndCat.element.style.width='';
	      this.dndCat.element.classList.remove('dragging');

	      //remove placeholder
	      document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); })

	      //popup para registrar usuário anonimo
			if(askRegisterAnonymous(this.$store.state)) {
				this.$router.push({name:'formRegistrar'});
				return;
			}

	    },



	    getBoxHover(x,y){
	    	var categories = document.querySelectorAll('.grid-item');
	    	var category_id = null;
	    	categories.forEach(category=>{
	    		var rect = category.getBoundingClientRect();
	    		if(x >= rect.x
	    			&& x <= rect.x+rect.width
	    			&& y >= rect.y
	    			&& y <= rect.y+rect.height) category_id = category.getAttribute('data-uid');
	    	});
	    	return category_id;
	    },

	    getLinkIndexHover(category_id,x,y){
	    	var links = this.categoryLinks(category_id);
	    	var index;
	    	var lastIndex = null;
	    	for (index in links){
	    		if(links[index].id == this.dndLinks.element.getAttribute('data-uid')) continue;
	    		var rect = document.querySelector('.link-item[data-uid="'+links[index].id+'"]').getBoundingClientRect();
	    		if(x >= rect.x
	    			&& x <= rect.x+rect.width
	    			&& y >= rect.y
	    			&& y <= rect.y+rect.height) return links[index].index;
	    			lastIndex = index;
	    	}
	    	var rect = document.querySelector('.link-item[data-uid="'+links[lastIndex].id+'"]').getBoundingClientRect();
	    	if((x >= rect.x+rect.width && y >= rect.y) || y>rect.y+rect.height) return links[lastIndex].index+1;
	    	return null
	    },


	    mousedownLinks(link,e){
	    	e.stopPropagation();

    		var coords = {
    			x:e.clientX,
    			y:e.clientY,
    		}
    		var offset = {
    			x:e.offsetX,
    			y:e.offsetY,
    		}

	    	this.dndLinks.link = link;
	    	this.dndLinks.element = document.querySelector('.link-item[data-uid="'+link.id+'"]');

	    	console.log('this.dndLinks.link',this.dndLinks.link);
	    	console.log('this.dndLinks.element',this.dndLinks.element);

	    	this.dndLinks.offset.x = offset.x;
	    	this.dndLinks.offset.y = offset.y;

	      //record coordinates to start draggin 10px after this
	      this.dndLinks.mouse.x = coords.x;
	      this.dndLinks.mouse.y = coords.y;

	      this.dndLinks.mouseDown = true;

	    },

	    mousemoveLinks(coords){
	    	var movePlaceholder = false;
	    	//this.debug = [coords, this.dndLinks.categoryHover, this.dndLinks.indexHover]
	    	if(!this.dndLinks.dragging){
	    		if(Math.abs(this.dndLinks.mouse.x-coords.x)<10 && Math.abs(this.dndLinks.mouse.y-coords.y)<10) return;
	    		this.dndLinks.dragging = true;
	    		this.$nextTick(()=>{
	    			this.dndLinks.element.classList.add('dragging');
	    		})
	    		movePlaceholder = true;
	    	}

	    	this.dndLinks.element.style.left = (coords.x - this.dndLinks.offset.x) + 'px';
	    	this.dndLinks.element.style.top = (coords.y - this.dndLinks.offset.y) + 'px';

	    	var categoryHover = this.getBoxHover(coords.x,coords.y);
	    	if(categoryHover && this.dndLinks.categoryHover!=categoryHover){
	    		console.log('change category ',categoryHover);
	    		this.dndLinks.categoryHover = categoryHover;
	    		movePlaceholder = true;
	    	}

	    	var indexHover = this.getLinkIndexHover(categoryHover,coords.x,coords.y);
	    	if(indexHover && this.dndLinks.indexHover!=indexHover){
	    		console.log('change index ',indexHover);
	    		this.dndLinks.indexHover = indexHover;
	    		movePlaceholder = true;
	    	}

	    	if(movePlaceholder && this.dndLinks.categoryHover) {
	        //remove existing placeholder
	        document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); });

	        //create new placeholder
	        var placeholder = document.createElement('div');
	        placeholder.className = 'link-item placeholder';

	        //insert on chosen position
	        var links = this.links.filter(link => link.category_id==this.dndLinks.categoryHover && link.index==this.dndLinks.indexHover);
	        if(links.length){
	        	var linkElement = document.querySelector('.link-item[data-uid="'+links[0].id+'"]');
	        	linkElement.parentNode.insertBefore(placeholder,linkElement);
	        } else {
	        	document.querySelector('.grid-item[data-uid="'+this.dndLinks.categoryHover+'"] .links-wrapper').appendChild(placeholder);
	        }
	      }
	    },

	    mouseupLinks(e){
	    	this.dndLinks.dragging = false;
	    	this.movendo = false;

	    	this.dndLinks.element.style.left= '';
	    	this.dndLinks.element.style.top= '';
	      document.querySelectorAll('.dragging').forEach((element) => { element.classList.remove('dragging'); })

	      //remove placeholder
	      document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); })

	    	if(!this.dndLinks.categoryHover) return;

	      //setar column do elemento arrastado
	      this.dndLinks.link.index = this.dndLinks.indexHover-0.5;

	      if(this.dndLinks.link.category_id!=this.dndLinks.categoryHover){
	      	var oldCategory = this.dndLinks.link.category_id;
	      	this.dndLinks.link.category_id=this.dndLinks.categoryHover;
		      this.$store.dispatch('updateLink',{link_id:this.dndLinks.link.id,data:this.dndLinks.link});
	      }

				//atualizar ordem dos itens somente das categorias afetadas
	      var reorderCategories = [];
	      reorderCategories.push(this.dndLinks.link.category_id);
	      if(oldCategory) reorderCategories.push(oldCategory);
	      this.$store.dispatch('reorderLinks',{categories:reorderCategories});

	      //popup para registrar usuário anonimo
			if(askRegisterAnonymous(this.$store.state)) {
				this.$router.push({name:'formRegistrar'});
				return;
			}

	    },


	    habilitaMover(item,e){
	    	e.stopPropagation();
	    	this.movendo = true;
	    	this.linkPreview = false;
	    	this.movendoItem = item;
	    },
	    touchstartLinks(item,e){

				var coords = {
					x:e.touches[0].pageX,
					y:e.touches[0].pageY,
				}
				var rect = e.target.getBoundingClientRect();
				var offset = {
					x:e.targetTouches[0].clientX - rect.left,
					y:e.targetTouches[0].clientY - rect.top,
				}

	    	this.dndLinks.link = item;
	    	this.dndLinks.element = document.querySelector('.link-item[data-uid="'+item.id+'"]');

	    	this.dndLinks.offset.x = offset.x;
	    	this.dndLinks.offset.y = offset.y;

	      //record coordinates to start draggin 10px after this
	      this.dndLinks.mouse.x = coords.x;
	      this.dndLinks.mouse.y = coords.y;

	      this.dndLinks.mouseDown = true;
	    },

			touchmoveLinks(e){
				var coords={x:e.touches[0].clientX, y:e.touches[0].clientY, }
	    	this.mousemoveLinks(coords)
			},



	    copyLink(item,evt){
			evt.stopPropagation();
			console.log('item.url',item.url)
			console.log('evt',evt)
			console.log('evt.target',evt.target)

			var button = evt.target;

			var newInput = document.createElement('input');
			newInput.setAttribute('type', 'text');
			newInput.value = item.url;
			document.body.appendChild(newInput);
			newInput.select();

			try {
				var successful = document.execCommand('copy');
				var msg = successful ? 'successful' : 'unsuccessful';
				var originalTxtButton = button.innerText;
				button.innerText = 'Copiado!';
				setTimeout(()=>{ button.innerText = originalTxtButton; },2000);
			} catch (err) {
				alert('Oops, unable to copy');
			}
			newInput.setAttribute('type', 'hidden');
			document.body.removeChild(newInput);
			window.getSelection().removeAllRanges();
    	
	    },


	    editLink(item){
	    	this.linkPreview = false;
	    	this.$router.push({name:'formLink', params: { category: item.category_id, item: item }})
	    },

	    categoryTheme(theme){
	    	if(!theme) return '';
	    	return 'category-theme-'+theme.replace(/ /g,'-');
	    },

	    removeLink(item){
	    	this.linkPreview = false;
	    	this.$store.dispatch('deleteLink',{link_id:item.id});
	    },

	    duplicateLink(item){
	    	this.linkPreview = false;
	    	var data = {
	    		category_id:item.category_id,
	    		name:item.name,
	    		url:item.url,
	    		favicon:item.favicon,
	    		index:item.index || 99,
	    	};

	    	this.$store.dispatch('addLink',{data:data});

	    },

	    editCategory(category){
	    	this.$router.push({name:'formCategory', params: { item: category }})
	    },
	    newLink(category){
	    	console.log('newlink');
	    	this.$router.push({name:'formLinkNew',params: {category:category.id}})
	    },


	    clickLink(item,e){
	    	if(isMobile()){
	    		e.preventDefault();
	    		e.stopPropagation();
	    		this.linkPreview = true;
	    		this.linkPreviewItem = item;
	    	}
	    },

	    contextMenu(item,e){
	    	e.preventDefault()
	    	var coords = {
    			x:e.pageX,
    			y:e.pageY,
    		}
	    	this.contextMenuItem = item;
	    	this.ctxmenu = true;

	    	var ctxMenu = document.getElementById("ctxMenu");
	    	var container = document.querySelector('.home');

	    	var left = coords.x;
				left -= container.offsetParent.offsetLeft;
				ctxMenu.style.left = left+"px";
				var top = coords.y;
				top -= container.offsetParent.offsetTop;
				ctxMenu.style.top = top+"px";

			},


		},
		created(){
			document.onkeydown = (evt) => {
				evt = evt || window.event;
				var isEscape = false;
				if ("key" in evt) {
					isEscape = (evt.key === "Escape" || evt.key === "Esc");
				} else {
					isEscape = (evt.keyCode === 27);
				}
				if (isEscape) {
					if(this.ctxmenu){
						this.ctxmenu = false;
					}
					if(this.configActive){
						this.configActive = false;
					}
				}
			}


			document.querySelector('body').addEventListener('mousemove',(e)=>{
				var coords={x:e.clientX, y:e.clientY, }
				if(this.dndCat.mouseDown) return this.mousemoveCategories(coords);
				if(this.dndLinks.mouseDown) return this.mousemoveLinks(coords);
			});
			document.querySelector('body').addEventListener('touchmove',(e)=>{
				var coords={x:e.touches[0].clientX, y:e.touches[0].clientY, }
				if(this.dndCat.mouseDown) return this.mousemoveCategories(coords);
			},{passive:false});

			document.querySelector('body').addEventListener('mouseup',(e)=>{
				this.dndCat.mouseDown = false;
				this.dndLinks.mouseDown = false;

				if(this.dndCat.dragging) return this.mouseupCategories(e);
				if(this.dndLinks.dragging) return this.mouseupLinks(e);

			});
			document.querySelector('body').addEventListener('touchend',(e)=>{
				this.dndCat.mouseDown = false;
				this.dndLinks.mouseDown = false;

				if(this.dndCat.dragging) return this.mouseupCategories(e);
				if(this.dndLinks.dragging) return this.mouseupLinks(e);

			});

			document.querySelector('body').addEventListener('click',(e)=>{
				if(this.linkPreview) this.linkPreview = false;
				if(this.ctxmenu) this.ctxmenu = false;
				if(this.movendo) this.movendo = false;
			});



		}

	}
</script>
